// src/lib/redacted.ts
//
// ★ A stored input field the server WITHHELD (UAT re-run F-06). A refused calculation no longer keeps free text that
// failed validation (a name, an identity number, a 5,000-character string); in its place the stored input holds
// `{ redacted: true, reason, length }`. Every screen that prints a stored input field reads it through here, so the
// marker is a sentence and never "[object Object]".
import type { RedactedField } from './types'

export function isRedactedField(value: unknown): value is RedactedField {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    (value as Record<string, unknown>)['redacted'] === true &&
    typeof (value as Record<string, unknown>)['length'] === 'number'
  )
}

/** "Withheld: wrong shape (12 characters)". The words say what happened; the original text is not kept anywhere. */
export function redactedText(value: RedactedField): string {
  const count = value.length === 1 ? '1 character' : `${value.length} characters`
  return `Withheld: wrong shape (${count})`
}

/** A stored field as text for a cell: the redaction sentence for a marker, else the string, else null. */
export function storedText(value: unknown): string | null {
  if (isRedactedField(value)) return redactedText(value)
  return typeof value === 'string' && value.length > 0 ? value : null
}
